

// src/app/shared/services/features.service.ts
import { Inject, Injectable } from '@angular/core';
import { PRODUCT_IDENTITY_TOKEN, FEATURES_TOKEN, GEOGRAPHICAL_SUMMARY_CONFIG_TOKEN } from '../../config/config.tokens';
import { ProductIdentity, Features as FeaturesModel, LegacySwitches, GeographicalSummaryConfig } from '../../config/config.model';

@Injectable({ providedIn: 'root' })
export class FeaturesService {
    // External interface unchanged
    public product: ProductIdentity;

    public isLegacyStartup: boolean;
    public isAssetSearchEnabled: boolean;
    public enableAssetDisplay: boolean;
    public useNewProjectDisplay: boolean;
    public useNewNotifications: boolean;
    public enableThemeSelector: boolean;
    public enableApiKeyManager: boolean;
    public enableApiSandbox: boolean;
    public enableAssetMarkerEditor: boolean;
    public enableDataCentreEditor: boolean;
    public enableLifecycleSecurity: boolean;
    public enableGeographicalSummary: boolean;
    public legacySwitches: LegacySwitches;

    constructor(
        @Inject(PRODUCT_IDENTITY_TOKEN) productIdentity: ProductIdentity,
        @Inject(FEATURES_TOKEN) features: FeaturesModel,
        @Inject(GEOGRAPHICAL_SUMMARY_CONFIG_TOKEN) geographicalSummary: GeographicalSummaryConfig
    ) {
        this.product = productIdentity;

        // Map with safe defaults (though features comes from config, so all keys should exist)
        this.isLegacyStartup = !!features.isLegacyStartup;
        this.isAssetSearchEnabled = !!features.isAssetSearchEnabled;
        this.enableAssetDisplay = !!features.enableAssetDisplay;
        this.useNewProjectDisplay = !!features.useNewProjectDisplay;
        this.useNewNotifications = !!(features.notifications?.useNewNotifications ?? features.useNewNotifications);
        this.enableThemeSelector = !!features.enableThemeSelector;
        this.enableApiKeyManager = !!features.enableApiKeyManager;
        this.enableApiSandbox = !!features.enableApiSandbox;
        this.enableAssetMarkerEditor = !!features.enableAssetMarkerEditor;
        this.enableDataCentreEditor = !!features.enableDataCentreEditor;
        this.enableLifecycleSecurity = !!features.enableLifecycleSecurity;
        this.enableGeographicalSummary = !!(features.enableGeographicalSummary || geographicalSummary?.enableNewGeographicalSummary);
        this.legacySwitches = features.legacySwitches;
    }
}



// import { Injectable } from '@angular/core';
// import { environment } from "src/environments/environment";

// interface Features {
//     isAssetSearchEnabled?: boolean;
//     enableAssetDisplay?: boolean;
//     useNewProjectDisplay?: boolean;
//     enableThemeSelector?: boolean;
//     enableApiKeyManager?: boolean;
//     enableAssetMarkerEditor?: boolean;
//     enableDataCentreEditor?: boolean;
//     // enableNewClassifications?: boolean[];

//    // useNewClassificationsForSectors?: boolean[];
//     enableLifecycleSecurity?: boolean;
// }


// @Injectable({
//     providedIn: 'root'
// })
// export class FeaturesService {
//     public product = environment.productIdentity;

//     features: Features = environment.features || {};

//     // this should allow the same set of feature toggles to
//     // be used by Angular and AngularJS portions of the app
//     // by injecting the FeaturesService
//     // Default values are provided to switch the feature off
//     // in case any keys are missing in production
//     public isAssetSearchEnabled = this.features.isAssetSearchEnabled ?? false;
//     public enableAssetDisplay = this.features.enableAssetDisplay ?? false;
//     public useNewProjectDisplay = this.features.useNewProjectDisplay ?? false;
//     public enableThemeSelector = this.features.enableThemeSelector ?? false;
//     public enableApiKeyManager = this.features.enableApiKeyManager ?? false;
//     public enableAssetMarkerEditor = this.features.enableAssetMarkerEditor ?? false;
//     public enableDataCentreEditor = this.features.enableDataCentreEditor ?? false;
//    //public enableNewClassifications = this.features.enableNewClassifications ?? false;
//     //     Upstream: false,                    //  1
//     //     Midstream: false,                   //  7
//     //     Downstream: false,                  //  2
//     //     Power: false,                       //  3
//     //     Renewables: false,                  //  6
//     //     TransmissionAndDistribution: false, //  8
//     //     Hydrogen: false,                    //  9
//     //     CarbonCapture: false,               // 10
//     //     EnergyStorage: false,               // 11
//     //     Other: false,                       //  5
//     // },
//    // public useNewClassificationsForSectors = this.features?.useNewClassificationsForSectors ?? false;
//     public enableLifecycleSecurity = this.features.enableLifecycleSecurity ?? false;
// }
